import { render, staticRenderFns } from "./fireAlarmInfo.vue?vue&type=template&id=63a9963d&scoped=true"
import script from "./fireAlarmInfo.vue?vue&type=script&lang=js"
export * from "./fireAlarmInfo.vue?vue&type=script&lang=js"
import style0 from "./fireAlarmInfo.vue?vue&type=style&index=0&id=63a9963d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9963d",
  null
  
)

export default component.exports